import { useMutation } from "@tanstack/react-query";
import { API_URL } from "src/Utils/API";
import { BulkCreateMenuRequest, BulkCreateMenuResult } from "../types/menu";

export const useBulkCreateMenu = (onSuccess?: () => void) => {
    return useMutation({
        mutationFn: async ({
            restaurantId,
            payload,
        }: {
            restaurantId: string;
            payload: BulkCreateMenuRequest;
        }) => {
            const response = await fetch(`${API_URL}/admin/restaurants/${restaurantId}/menu/bulk`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });
            const data = await response.json();
            if (!data.success) {
                throw new Error(data.error || "Failed to bulk create menu");
            }
            return data.data as BulkCreateMenuResult;
        },
        onSuccess,
    });
};
